import React from "react";
import { BabyIcon, CheckCircle2Icon, MessageCircleIcon, StethoscopeIcon, UsersIcon, XCircleIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { audiences, blueprintIs } from "../../data/content";
const icons = [BabyIcon, MessageCircleIcon, StethoscopeIcon, UsersIcon];
export function Audience() {
  return <section className="bg-plum-50 px-4 py-14 sm:py-20" data-id="element-60" data-mp="1hysk2lppuc9p">
      <div className="mx-auto max-w-4xl" data-id="element-61" data-mp="25nbrz04usn19">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-62" data-mp="25oms8pz3bcnm">
          Built for Pediatric Professionals Who Need Practical Tools—
          <span className="text-plum-600" data-id="element-63" data-mp="1wmnafvg944jm">Not Another Academic Manual</span>
        </h2>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-64" data-mp="21kx6e89sv96a">
          {audiences.map((a, i) => {
          const Icon = icons[i];
          return <div key={a.title} className="flex gap-4 rounded-2xl bg-white p-5" data-id="element-65" data-mp="q735wznguabo" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-mint-100 text-mint-700" data-id="element-66" data-mp="q4qe7urwollf">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-67" data-mp="unglh25rmk98" />
                </span>
                <div data-id="element-68" data-mp="19khfxdfcctbe">
                  <h3 className="font-display text-lg font-extrabold leading-snug text-plum-950" data-id="element-69" data-mp="19l0o42f6w3c8">{a.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-slate-700" data-id="element-70" data-mp="14kcwpfn1tkhh">{a.text}</p>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-71" data-mp="1dmccy5q8okjd">
          <div className="rounded-3xl bg-white p-6 ring-2 ring-mint-400" data-id="element-72" data-mp="1dlswyuk5g67z">
            <h3 className="font-display text-xl font-extrabold text-mint-700" data-id="element-73" data-mp="1s9now8qc26k0">What This Blueprint Is</h3>
            <p className="mt-1 text-sm text-slate-600" data-id="element-74" data-mp="1nd70rej4vs6x">A practical professional resource containing:</p>
            <ul className="mt-4 space-y-2.5" data-id="element-75" data-mp="21c6psnak693m">
              {blueprintIs.map(b => <li key={b} className="flex items-start gap-2 text-[15px] font-medium text-slate-800" data-id="element-76" data-mp="1xbd1vtx48uaq">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-77" data-mp="24ekwmc5di8cj" />
                  {b}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-white p-6 ring-2 ring-slate-200" data-id="element-78" data-mp="2eanzxlbyod12">
            <h3 className="font-display text-xl font-extrabold text-slate-800" data-id="element-79" data-mp="2j2eek3hxlmya">What This Blueprint Is Not</h3>
            <p className="mt-4 flex items-start gap-2 text-[15px] leading-relaxed text-slate-700" data-id="element-80" data-mp="2n2pxnbunbf7n">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-81" data-mp="2s1t4n1u6rvi9" />
              It is not a substitute for professional training, supervised clinical experience, individualized evaluation,
              medical assessment, or established safety protocols.
            </p>
            <p className="mt-3 flex items-start gap-2 text-[15px] leading-relaxed text-slate-700" data-id="element-82" data-mp="12oy02j7y33tt">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-83" data-mp="17o0xpilli7rr" />
              It does not provide universal treatment instructions, determine swallowing safety, or guarantee feeding
              outcomes.
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-84" data-mp="3c45tagd4rvh0">
          <CtaButton label="This Is For Me — Get Instant Access" sub="One-time payment of $27" data-id="element-85" data-mp="3c5gy8jibb99p" />
        </div>
      </div>
    </section>;
}